<template>
    <div class="form-field" :rel="name" v-bind:class="{'has-suffix': suffix}">
        <div class="form-label">
            <label>{{ label }}</label>
        </div>
        <div class="form-input">
            <div class="form-input-wrapper">
                <input type="text" value="" v-model="internalValue"/>
                <span class="suffix" v-if="suffix"><span>{{ suffix }}</span></span>
              <div class="bt-action" style="display: flex;position: absolute;top: 50%; right: 0;transform: translateY(-50%);">
                <button @click="generate" class="bt-remove"><i class="icon icon-icon_refresh"></i></button>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FormPassword',
        props: ['value','label','suffix','name'],
        data: function () {
            return {
                size: 10,
                internalValue: '',
                characters: 'a-z,A-Z,0-9,#'
            }
        },
        created: function() {
            this.internalValue = this.value;
        },
        methods: {
          generate: function() {
            let charactersArray = this.characters.split(',');
            let CharacterSet = '';
            let password = '';

            if( charactersArray.indexOf('a-z') >= 0) {
              CharacterSet += 'abcdefghijklmnopqrstuvwxyz';
            }
            if( charactersArray.indexOf('A-Z') >= 0) {
              CharacterSet += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
            }
            if( charactersArray.indexOf('0-9') >= 0) {
              CharacterSet += '0123456789';
            }
            if( charactersArray.indexOf('#') >= 0) {
              CharacterSet += '!%@_-#';
            }

            for(let i=0; i < this.size; i++) {
              password += CharacterSet.charAt(Math.floor(Math.random() * CharacterSet.length));
            }
            this.internalValue = password;
          }
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            },
            'internalValue'(newVal, oldVal) {
                this.$emit('input', this.internalValue);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/form/Password.vue